export default {
  list: {
    name: "transfer accounts list api",
    version: 6,
    url: "wechat/transfer-accounts",
    method: "GET",
  },
  create: {
    name: "create transfer account api",
    version: 6,
    url: "wechat/transfer-accounts",
    method: "POST",
  },
  update: {
    name: "update transfer account api",
    version: 6,
    url: "wechat/transfer-accounts/%{id}",
    method: "PUT",
  },
  delete: {
    name: "delete transfer account api",
    version: 6,
    url: "wechat/transfer-accounts/%{id}",
    method: "DELETE",
  },
};
